// extracted by mini-css-extract-plugin
export default {"wrap":"iH-z","logoContainer":"jH-z","brandImg":"kH-z","logoImg":"lH-z","logoButton":"mH-z"};